import { Component, OnInit, Input } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  query,
  animateChild,
  keyframes,
} from '@angular/animations';

@Component({
  selector: 'app-info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.scss'],
  animations: [
    trigger('popup', [
      transition(':enter', [
        style({ opacity: '0', transform:'scale(.9)' }),
        animate('.3s ease-in-out', style({ opacity: '1', transform:'scale(1)' })),
      ]),
      transition(':leave', [
        style({ opacity: '1', transform:'scale(1)' }),
        animate('.3s ease-in-out', style({ opacity: '0', transform:'scale(.9)' })),
      ]),
    ]),
  ],
})
export class InfoPopupComponent implements OnInit {

  @Input() isOpen = false;
  @Input() position: {top?:string, bottom?:string, left?:string, right?:string};

  constructor() { }

  ngOnInit() {}

  show(){
    this.isOpen = true;
  }

  close(){
    this.isOpen = false;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/info-popup/info-popup.component.ts